import axios from './api.request'
import qs from 'qs'
import configData from './conf.js'

// 获取课程信息
export const getMarketInfo = (activityId) => {
  let data = {
    activityId: activityId
  }
  return axios.request({
    url: '/market/v1/web/market/info',
    params: data,
    method: 'GET'
  })
}

// 获取营销纬度
export const getMarketDimension = (data) => {
  return axios.request({
    url: '/market/v1/web/market/dimension',
    params: data,
    method: 'GET'
  })
}

// 获取班级列表
export const getMarketClassList = (data) => {
  return axios.request({
    url: '/market/v1/web/market/classListOnNoLive',
    params: data,
    method: 'GET'
  })
}

// 记录用户渠道
export const recordChannel = (data) => {
  return axios.request({
    url: '/market/v1/web/channel/add',
    params: data,
    method: 'GET'
  })
}

// 获取高端班级列表
export const getHighEndClassList = (data) => {
  return axios.request({
    url: '/market/v1/web/market/getHighEndClassList',
    params: data,
    method: 'GET'
  })
}

// 缓存信息
// 获取课程信息
export const getNewMarketInfo = (activityId) => {
  let data = {
    activityId: activityId
  }
  return axios.request({
    url: '/market/v1/web/market/info',
    params: data,
    method: 'GET'
  })
}

// 班级列表
export const getNewMarketClassList = (data) => {
  return axios.request({
    url: '/market/v1/web/market/classList',
    params: data,
    method: 'GET'
  })
}

// 是否开启缓存
export const getRedis = () => {
  return axios.request({
    url: '/market/v1/web/common/getRedis',
    params: {key: 'ACTIVITY_MARKET_ISOPEN'},
    method: 'GET'
  })
}


// 登陆授权验证
export const checkWxLogin = () => {
  return axios.request({
    url: `/common/check/wx`,
    method: 'GET'
  })
}

// 加入购物车
export const addCartApi = (data) => {
  return axios.request({
    url: `${configData.bm}/web_reg_uapi/cart/add`,
    method: 'POST',
    data,
  })
}

// 获取购物车列表
export const getCartCountApi = (data) => {
  console.log('******-----数量', data)
  return axios.request({
    url: `${configData.bm}/web_reg_uapi/cart/getCount`,
    method: 'GET',
    params: data
  })
}

// 获取当前用户的学员列表
export const getStudentList = (params) => {
  return axios.request({
    url: '/api/usercenter/student/list',
    method: 'GET',
    params,
  })
}

// 记录用户渠道
export const getGan = (data) => {
  return axios.request({
    url: '/market/v1/web/channel/get',
    params: data,
    method: 'GET'
  })
}

// 添加优惠计算接口 - 使用 JSON 格式
export const calculatePreferential = (data) => {
  return axios.request({
    url: '/api/preferential/precomputation/class-simple',
    data: data,  // 直接传递 JSON 对象
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  });
}
// 获取礼品规则
export const getGiftRules = (activityId) => {
  return axios.request({
    url: '/market/v1/web/rule/buy-gift/get',
    method: 'GET',
    params: {
      activityId: activityId
    }
  })
}
